function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_4481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 2.42098V5.17467C9.33329 5.54804 9.33329 5.73473 9.40595 5.87733C9.46987 6.00278 9.57186 6.10476 9.6973 6.16868C9.83991 6.24134 10.0266 6.24134 10.4 6.24134H13.1537M10.6666 9.57463H5.33329M10.6666 12.2413H5.33329M6.66663 6.90796H5.33329M9.33329 2.24129H5.86663C4.74652 2.24129 4.18647 2.24129 3.75864 2.45928C3.38232 2.65103 3.07636 2.95699 2.88461 3.33331C2.66663 3.76114 2.66663 4.32119 2.66663 5.44129V12.3746C2.66663 13.4947 2.66663 14.0548 2.88461 14.4826C3.07636 14.8589 3.38232 15.1649 3.75864 15.3566C4.18647 15.5746 4.74652 15.5746 5.86663 15.5746H10.1333C11.2534 15.5746 11.8134 15.5746 12.2413 15.3566C12.6176 15.1649 12.9236 14.8589 13.1153 14.4826C13.3333 14.0548 13.3333 13.4947 13.3333 12.3746V6.24129L9.33329 2.24129Z",
    stroke: "#697586",
    style: {
      stroke: "#697586",
      stroke: "color(display-p3 0.4124 0.4574 0.5249)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_4481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0 0.907959)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d410cbee637c89a59bedea944efa777d.svg";
export { ForwardRef as ReactComponent };